import {ChangeDetectorRef, Component} from "@angular/core";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {OrderActionDisplayEntityModel} from "../order-action-display-entity.model";
import {OrderActionData, OrderActionType} from "../order-action-display.data";

@Component({
    selector: "wbo-order-action-display-edit-page",
    templateUrl: "./order-action-display-edit-page.component.html",
    providers: [
        provideEntityModel(OrderActionDisplayEntityModel)
    ]
})
export class OrderActionDisplayEditPageComponent extends AbstractEditPage {

    OrderActionType = OrderActionType;

    constructor(public model: OrderActionDisplayEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    orderActionNotificationMessage(orderAction: OrderActionData): string {
        return orderAction.description && orderAction.location ? "wbo.order-action-display.edit.message.orderReady.orderDescriptionReadyFromLocation"
            : orderAction.description ? "wbo.order-action-display.edit.message.orderReady.orderDescriptionReady"
                : orderAction.location ? "wbo.order-action-display.edit.message.orderReady.orderReadyFromLocation"
                    : "wbo.order-action-display.edit.message.orderReady.orderReady";
    }

    changeSite(): void {
        this.model.data.webTerminalIds = [];
    }

    outletsChanged(): void {
        if (this.model.data.outletIds.length) {
            this.model.data.terminalIds = [];
            this.model.data.webTerminalIds = [];
        }
    }

    terminalsChanged(): void {
        if (this.model.data.terminalIds.length) {
            this.model.data.outletIds = [];
            this.model.data.webTerminalIds = [];
        }
    }

    webTerminalsChanged(): void {
        if (this.model.data.webTerminalIds.length) {
            this.model.data.outletIds = [];
            this.model.data.terminalIds = [];
        }
    }
}
